// Vite alias target for `next/link` imports inside @edemics/components.
// Adapts Next's Link API to react-router-dom's Link — good-enough
// compatibility for the ~67 files that import next/link in the shared
// components package.
//
// Missing vs Next: prefetch, scroll-restore priorities, locale routing.
// If a specific component needs any of those, refactor that call site.

import { forwardRef, type ComponentPropsWithoutRef } from "react"
import { Link as RouterLink } from "react-router-dom"

type NextLinkProps = ComponentPropsWithoutRef<"a"> & {
  href: string | { pathname: string; query?: Record<string, string> }
  as?: string
  replace?: boolean
  scroll?: boolean
  shallow?: boolean
  passHref?: boolean
  prefetch?: boolean
  locale?: string | false
  legacyBehavior?: boolean
}

function hrefToString(href: NextLinkProps["href"]): string {
  if (typeof href === "string") return href
  const query = href.query
    ? "?" + new URLSearchParams(href.query as Record<string, string>).toString()
    : ""
  return `${href.pathname}${query}`
}

const Link = forwardRef<HTMLAnchorElement, NextLinkProps>(function Link(
  {
    href,
    as: _as,
    replace,
    scroll: _scroll,
    shallow: _shallow,
    passHref: _passHref,
    prefetch: _prefetch,
    locale: _locale,
    legacyBehavior: _legacyBehavior,
    ...rest
  },
  ref,
) {
  return <RouterLink ref={ref} to={hrefToString(href)} replace={replace} {...(rest as any)} />
})

export default Link
export { Link }
